import { z } from 'zod';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

export const defaultCurrencySchema = z.object({
  currency: z.enum(Currency, {
    error: 'Wybierz walutę',
  }),
});

export type DefaultCurrencyFormData = z.infer<typeof defaultCurrencySchema>;
